/**
 * The notice that a new version of the desk is ready (see lib/newVersion.ts). It never reloads the page by itself: the person
 * chooses when, after finishing what they are typing. "Later" hides it until the page is next opened.
 */
import { useState } from 'react';
import { useNewVersionReady } from '../lib/newVersion';
import { Button } from '../ui/primitives';

export function NewVersionBanner() {
  const ready = useNewVersionReady();
  const [hidden, setHidden] = useState(false);
  if (!ready || hidden) return null;
  return (
    <div role="status" aria-live="polite"
         className="fixed bottom-6 left-6 z-50 flex w-96 max-w-[calc(100vw-3rem)] flex-col gap-3 rounded-[var(--radius-panel)] border border-line bg-surface p-4 shadow-[var(--shadow-overlay)]">
      <p className="text-body">A new version of the desk is ready. Refresh when you have finished what you are typing; nothing is lost until you do.</p>
      <div className="flex justify-end gap-2">
        <Button size="dense" onClick={() => setHidden(true)}>Later</Button>
        <Button size="dense" variant="primary" onClick={() => window.location.reload()}>Refresh now</Button>
      </div>
    </div>
  );
}
